import { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ArrowRight } from "lucide-react";
import { Input } from "../components/ui/input";
const LOGO_URL = "/logo.png";

export default function RegisterPage() {
  const [name, setName] = useState(""); const [email, setEmail] = useState(""); const [password, setPassword] = useState("");
  const [error, setError] = useState(""); const [loading, setLoading] = useState(false);
  const { register } = useAuth(); const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try { await register(name, email, password); navigate("/dashboard"); }
    catch (err) { const d = err.response?.data?.detail; setError(typeof d === "string" ? d : Array.isArray(d) ? d.map(e => e.msg).join(" ") : "Registration failed"); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen auth-container flex items-center justify-center px-6 py-24">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/"><img src={LOGO_URL} alt="Fly In Visa" className="h-20 w-auto object-contain mx-auto mb-6 rounded-lg" /></Link>
          <h1 className="heading-font text-3xl font-bold text-slate-900 mb-2">Create Account</h1>
          <p className="text-sm text-slate-500">Start your visa journey today</p>
        </div>
        <div className="card-elevated rounded-2xl p-7">
          <form onSubmit={handleSubmit} className="space-y-4">
            {error && <div data-testid="register-error" className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-4 py-3">{error}</div>}
            <div><label className="text-sm text-slate-600 mb-1.5 block font-medium">Full Name</label>
              <Input data-testid="register-name" value={name} onChange={e => setName(e.target.value)} placeholder="John Doe" required className="h-11 rounded-lg border-slate-200 focus-visible:ring-blue-500/30 focus-visible:border-blue-500" /></div>
            <div><label className="text-sm text-slate-600 mb-1.5 block font-medium">Email</label>
              <Input data-testid="register-email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" required className="h-11 rounded-lg border-slate-200 focus-visible:ring-blue-500/30 focus-visible:border-blue-500" /></div>
            <div><label className="text-sm text-slate-600 mb-1.5 block font-medium">Password</label>
              <Input data-testid="register-password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Min 6 characters" required minLength={6} className="h-11 rounded-lg border-slate-200 focus-visible:ring-blue-500/30 focus-visible:border-blue-500" /></div>
            <button type="submit" disabled={loading} data-testid="register-submit"
              className="w-full h-11 text-white font-semibold bg-blue-600 rounded-lg hover:bg-blue-700 transition-all flex items-center justify-center gap-2 disabled:opacity-50 shadow-sm">
              {loading ? "Creating..." : <><span>Create Account</span><ArrowRight className="w-4 h-4" /></>}
            </button>
          </form>
        </div>
        <p className="text-center text-sm text-slate-500 mt-5">Already have an account? <Link to="/login" className="text-blue-600 hover:text-blue-700 font-medium">Sign in</Link></p>
      </motion.div>
    </div>
  );
}
